import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import FlagstoneTheme from '../../../config/flagstoneTheme';

export default function ResultComponent(props) {

    const classes = useStyles();

    const getBackgroundColor = (success) => {
        if(success){
            return "rgba(69, 139, 0,0.1)"
        }
        else{
            return "rgba(255,0,0,0.1)"
        }
    }

    return (

        <div className={classes.container}>
            <div className={classes.title}>Executed scripts:</div>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.leftHeadCell} width={"10%"}>
                            Success
                        </TableCell>
                        <TableCell className={classes.headCell} width={"50%"} align="left">Script</TableCell>
                        <TableCell className={classes.headCell} width={"40%"} align="left">Error message</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.executeResults.map((result) => (
                        <TableRow key={result.scriptName} className={classes.row}>
                            <TableCell className={classes.leftCell} style={{backgroundColor:getBackgroundColor(result.executionSuccess)}}>
                                {result.executionSuccess ?
                                    <CheckIcon className={classes.ok}></CheckIcon>
                                    :
                                    <CloseIcon className={classes.notOk}></CloseIcon>
                                }
                            </TableCell>
                            <TableCell className={classes.midCell} align="left" style={{backgroundColor:getBackgroundColor(result.executionSuccess)}}>{result.scriptName}</TableCell>
                            <TableCell className={classes.rightCell} align="left" style={{backgroundColor:getBackgroundColor(result.executionSuccess)}}>{result.executionSuccess ? "/" : result.errorMessage}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <button className={classes.executeButton} onClick={() => props.restart()}>RESTART</button>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        padding: "50px",
        width: "100%"
    },
    title: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "left",
    },
    leftHeadCell: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        padding: "0px",
        paddingLeft: "20px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    headCell: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        padding: "0px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    leftCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px",
    },
    midCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "10px",
        paddingRight: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
    },
    rightCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        backgroundColor: "white",
        paddingRight: "10px",
        paddingLeft: "5px",
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%",
        marginTop: "30px"
    },
    executeButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        marginTop: "30px",
        color: "white",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: "18px",
        width: "150px",
        height: "40px"
    },
    ok: {
        color: "#458B00",
        height:"30px !important",
        width:"30px !important"
    },
    notOk:{
        color:"red",
        height:"30px !important",
        width:"30px !important"
    }
});